import { render, staticRenderFns } from "./SGScripts.vue?vue&type=template&id=7af98602"
import script from "./SGScripts.vue?vue&type=script&lang=js"
export * from "./SGScripts.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports